import {GET_USER, GET_CURRENT_COLLABORATOR} from '../../constants';
import {REQUEST} from '../../ActionType';
import {LOGIN_USER, LOGOUT_USER, REQUEST_PASSWORD, CHANGE_PASSWORD, RESET_PASSWORD} from '../../constants';

export const loginUserAction = (user,onSuccess) => {
    return {
        type: REQUEST(LOGIN_USER),
        user,
        onSuccess,
        loading:true,
    };
};

export const passwordChange = (request) => {
    return {
        type: REQUEST(CHANGE_PASSWORD),
        request,
        loading:true,
    };
};
export const passwordReset = (request) => {
    return {
        type: REQUEST(RESET_PASSWORD),
        request,
        loading:true,
    };
};

export const requestPassword = (email) => {
    return {
        type: REQUEST(REQUEST_PASSWORD),
        email,
        loading:true,
    };
};

export const getCurrentUser = token => {
    return {
        type: REQUEST(GET_USER),
        token
    };
};

export const getCurrentCollaborator = () => ({
    type: REQUEST(GET_CURRENT_COLLABORATOR),
});

export const logout= () => {
    return {
        type: REQUEST(LOGOUT_USER)
    };
};
